export const FETCH_TOEGANGSCONTROLES = 'fetch_toegangscontroles';
export const FETCH_TOEGANGSCONTROLE = 'fetch_toegangscontrole';
export const SAVE_TOEGANGSCONTROLE = 'save_toegangscontrole';
export const TOGGLE_TOEGANGSCONTROLE = 'toggle_toegangscontrole';
export const TEST_TOEGANGSCONTROLE = 'test_toegangscontrole';
export const START_AUTHORIZATION = 'start_authorization';
export const REFRESH_TOKEN = 'refresh_token';
export const TOEGANGSCONTROLE_ERROR = 'toegangscontrole_error';

// Doorsy API types
export const FETCH_DOORSY_RESERVATIONS = 'fetch_doorsy_reservations';
export const FETCH_DOORSY_RESERVATION = 'fetch_doorsy_reservation';
export const SYNC_DOORSY_RESERVATIONS = 'sync_doorsy_reservations';
export const TEST_DOORSY_CONNECTION = 'test_doorsy_connection';
export const FETCH_DOORSY_USER_INFO = 'fetch_doorsy_user_info';
export const FETCH_DOORSY_SYSTEM_INFO = 'fetch_doorsy_system_info';
export const FETCH_DOORSY_REALESTATES = 'fetch_doorsy_realestates';
export const CREATE_DOORSY_REALESTATE = 'create_doorsy_realestate';
export const DOORSY_ERROR = 'doorsy_error';

// Toegangscode types
export const CREATE_TOEGANGSCODE = 'create_toegangscode';
export const FETCH_TOEGANGSCODES = 'fetch_toegangscodes';
export const FETCH_TOEGANGSCODE = 'fetch_toegangscode';
export const DEACTIVEER_TOEGANGSCODE = 'deactiveer_toegangscode';
export const DELETE_TOEGANGSCODE = 'delete_toegangscode';
export const VALIDATE_TOEGANGSCODE = 'validate_toegangscode';
export const TOEGANGSCODE_ERROR = 'toegangscode_error';